<template>
    <div class="mt-4">
        <b-form-group
                vertical
                :label-cols="2"
                breakpoint="lg"
                label="Notes">
            <b-form-textarea @input="dataSetter($event, 'notes')" :rows="10"
                             v-model="appointment.notes"></b-form-textarea>
        </b-form-group>
    </div>
</template>

<script>
  import FormDataSetter from '@/mixins/form-data-setter';

  export default {
    props: {
      appointment: {
        type: Object
      }
    },
    mixins: [FormDataSetter]
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Form/NotesTab.vue